import { Box, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import PropTypes from "prop-types";

export const TermsAndConditions = ({ termsAndConditionsData }) => {
  const { t } = useTranslation();


  const getProcessedContent = (data) => {
    if (!data) return null;

    if (/<[a-z][\s\S]*>/i.test(data)) {
      return data;
    }

    return data.replaceAll(/\n/, '<br />');
  };
  const processedContent = getProcessedContent(termsAndConditionsData);

  return (
    <div className="applicantDetailsCard">
      <h3 className="titlePersonalHD marginBottom28">
        {t("termsAndConditions.title")}
      </h3>
      {processedContent ? (
        <Box
          id="terms-description"
          dangerouslySetInnerHTML={{ __html: processedContent }}

        />
      ) : (
        <Typography id="terms-description" variant="body2" sx={{ fontWeight: 500 }}>
          {t("termsAndConditions.noTermsAndConditions")}

        </Typography>
      )}
    </div>

  )
}



TermsAndConditions.propTypes = {
  termsAndConditionsData: PropTypes.object,
};
